import { render, staticRenderFns } from "./ReviewerActionsMenu.vue?vue&type=template&id=d2c79060&scoped=true&"
import script from "./ReviewerActionsMenu.vue?vue&type=script&lang=js&"
export * from "./ReviewerActionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ReviewerActionsMenu.vue?vue&type=style&index=0&id=d2c79060&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c79060",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VMenu,VOverlay,VTooltip})
